<template>
  <div v-if="getDeliveryCountrySelected !== undefined" class="order-delivery-country-selector">
    <div class="order-delivery-country-selector_title">
      Доставка в
    </div>
    <div class="order-delivery-country-selector_wrapper">
      <div class="order-delivery-country-selector_active">
        {{ getDeliveryCountrySelected.name }}
      </div>
      <div class="order-delivery-country-selector_list">
        <div
          v-for="item in getDeliveryCountryUnselected"
          :key="item.id"
          class="order-delivery-country-selector_list-item"
          @click="setDeliveryCountryById(item.id)">
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'

  export default {
    name: 'CountrySelector',
    computed: {
      ...mapGetters('order', [
        'getDeliveryCountryList',
        'getDeliveryCountrySelected',
        'getDeliveryCountryUnselected'
      ])
    },
    methods: {
      ...mapActions('order', [
        'setDeliveryCountryById'
      ])
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Order/Delivery/CountrySelector.vue